import jsQR from "jsqr";

import { translations } from "@/shared/localization/translations";
import { logError } from "@/shared/logging/errors";

import { Overlay } from "@/components/dialog/Overlay";

export class QrVoucherCodeScanner extends Overlay {
    private stream?: MediaStream;
    private player: JQuery;
    private video: HTMLVideoElement;
    private qrDecoderInterval?: number;
    public onCodeDetected?: { (code: string) };

    constructor() {
        super();

        this.$element.append(
            `<div class="head"><b>${translations.qrScanner.scanQr}</b><p>${translations.qrScanner.pointCameraQr}</p></div>`
        );
        const inner = $('<div class="inner" />').appendTo(this.$element.addClass("qrscanner"));
        this.player = $('<video class="video" />').appendTo(inner);

        this.video = this.player[0] as HTMLVideoElement;
        this.video.setAttribute("playsinline", "");
        this.video.setAttribute("autoplay", "");
        this.video.setAttribute("muted", "");

        $('<div class="closer">' + translations.general.close + "</div>")
            .appendTo(this.$element)
            .click((e) => {
                e.preventDefault();
                this.stopCamera();
            });
    }

    public async start(): Promise<void> {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment", aspectRatio: { ideal: 1 } },
                audio: false,
            });

            this.show();
            this.stream = stream;
            this.streamCamera();
        } catch (ex) {
            logError(ex);
            throw new Error("Failed to access camera stream.");
        }
    }

    private streamCamera() {
        this.video.srcObject = this.stream || null;
        this.video.play();

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        this.qrDecoderInterval = window.setInterval(() => {
            if (!context) return;

            canvas.width = this.video.videoWidth;
            canvas.height = this.video.videoHeight;
            context.drawImage(this.video, 0, 0, canvas.width, canvas.height);

            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            const code = jsQR(imageData.data, imageData.width, imageData.height);

            if (code != null && code.data != null && code.data.length > 0) {
               // const permalinkCode = this.getVoucherCode(code.data);
                
                    this.stopCamera();

                    if (this.onCodeDetected) {
                        this.onCodeDetected(code.data);
                    }
                
            }
        }, 100);
    }

    private async stopCamera() {
        if (this.qrDecoderInterval) {
            window.clearInterval(this.qrDecoderInterval);
            this.qrDecoderInterval = undefined;
        }

        await this.hide();
        if (this.stream !== undefined) {
            const tracks = this.stream.getVideoTracks();
            if (tracks.length > 0) tracks[0].stop();
        }
    }
}
